module.exports = __webpack_public_path__ + "static/media/shareIcon.ccc78d45.svg";